import { FetchError, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { AppConfig } from '../../../config/AppConfig';
import { LocalStorage, ACCESS_TOKEN, ID_TOKEN } from '../../../util/LocalStorage';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostProfileImage = () => {
    const { t } = useTranslation('newNotifications');
    const storage: LocalStorage = useContainer(LocalStorage);
    const toastHandler = useContainer(ToastStateHandler);

    const exec = async (image: File, callback: ICallback) => {
        const formData = new FormData();
        formData.append('image', image, image.name);

        const headers = new Headers();
        const accessToken = storage.get(ACCESS_TOKEN);
        const idToken = storage.get(ID_TOKEN);
        if (accessToken && idToken) {
            headers.append('X-Id-Token', idToken);
            headers.append('Authorization', `Bearer ${accessToken}`);

            const formdata = new FormData();
            formdata.append('image', image, image.name);

            const requestOptions: any = {
                method: 'POST',
                headers: headers,
                body: formdata,
                redirect: 'follow',
            };

            try {
                const res = await fetch(`${AppConfig.serverUrlBase}/usr/v1/user/profilePhoto`, requestOptions);
                const data = await res.json();
                if (!res.ok) throw new FetchError(res.status, res.ok, data?.fault?.message || data?.message || 'Error');
                if (callback.onSuccess) callback.onSuccess(data.body);
                toastHandler.push('success', t('user.imageUploadTitle'), t('user.imageUploadSuccess'));
            } catch (e: any) {
                toastHandler.push('error', t('user.imageUploadTitle'), e.message);
            }
        }
    };

    return {
        exec,
    };
};

export default useHttpPostProfileImage;
